<div class="it-menu">
  <div class="it-menu-body">

    <!-- 左：共通メニュー -->
    <div class="it-common-menu-container">
      <img class="it-logo" [src]="itLogoSrc" alt="サポートサイト" (click)="onClickSupportSite()" />

      <!-- 提供共通メニューのタイル表示パターン -->
      <ng-template #offerTile let-item>
        <button *ngIf="item?.businessMenuContentName" class="btn it-common-menu-item it-tile" (click)="onClickMenu(item)">
          <div class="it-tile__icon" [ngClass]="item?.businessMenuIconCss"></div>
          <span class="it-tile__label">{{ item?.businessMenuContentName }}</span>
        </button>
        <div *ngIf="!item?.businessMenuContentName" class="it-common-menu-item it-common-menu-item--empty it-tile">
          <div class="it-tile__icon"></div>
          <span class="it-tile__label"></span>
        </div>
      </ng-template>

      <!-- ユーザー登録共通メニューのタイル表示パターン（未登録時は空枠） -->
      <ng-template #userTile let-item>
        <button *ngIf="item?.businessMenuContentId" class="btn it-common-menu-item it-tile" (click)="onClickMenu(item)">
          <div class="it-tile__icon menu-common"></div>
          <span class="it-tile__label">{{ item?.businessMenuContentName }}</span>
        </button>
        <div *ngIf="!item?.businessMenuContentId" class="it-common-menu-item it-common-menu-item--empty it-tile">
          <div class="it-tile__icon"></div>
          <span class="it-tile__label"></span>
        </div>
      </ng-template>

      <div class="it-common-menu-row">
        <div class="it-common-menu-col--wide"><ng-container *ngTemplateOutlet="offerTile; context: { $implicit: offerMenuContents[0] }"></ng-container></div>
        <div><ng-container *ngTemplateOutlet="offerTile; context: { $implicit: offerMenuContents[1] }"></ng-container></div>
      </div>
      <div class="it-common-menu-row">
        <div><ng-container *ngTemplateOutlet="offerTile; context: { $implicit: offerMenuContents[2] }"></ng-container></div>
        <div><ng-container *ngTemplateOutlet="offerTile; context: { $implicit: offerMenuContents[3] }"></ng-container></div>
        <div><ng-container *ngTemplateOutlet="offerTile; context: { $implicit: offerMenuContents[4] }"></ng-container></div>
      </div>
      <div class="it-common-menu-row">
        <div><ng-container *ngTemplateOutlet="offerTile; context: { $implicit: offerMenuContents[5] }"></ng-container></div>
        <div><ng-container *ngTemplateOutlet="offerTile; context: { $implicit: offerMenuContents[6] }"></ng-container></div>
        <div><ng-container *ngTemplateOutlet="offerTile; context: { $implicit: offerMenuContents[7] }"></ng-container></div>
      </div>
      <div class="it-common-menu-row">
        <div><ng-container *ngTemplateOutlet="offerTile; context: { $implicit: offerMenuContents[8] }"></ng-container></div>
        <div><ng-container *ngTemplateOutlet="userTile; context: { $implicit: userMenuContents[0] }"></ng-container></div>
        <div><ng-container *ngTemplateOutlet="userTile; context: { $implicit: userMenuContents[1] }"></ng-container></div>
      </div>
    </div>

    <!-- 中央：プロダクトグループ -->
    <div class="it-product-group-container">
      <ng-container *ngFor="let group of productMenuGroups; let i = index">
        <div
          *ngIf="group?.businessMenuGroupId"
          class="it-product-group-item it-tile"
          [ngClass]="activeProductCssClass"
          [class.product-maintenance]="group.businessMenuGroupId === BusinessMenuGroupId.Maintenance"
          [class.product-carsales]="group.businessMenuGroupId === BusinessMenuGroupId.Carsales"
          [class.product-repair]="group.businessMenuGroupId === BusinessMenuGroupId.Repair"
          [class.active]="i === _activeGroupIndex"
          (click)="onClickProductMenuGroup(i, group.businessMenuGroupId)"
        >
          <div class="it-tile__icon" [ngClass]="group.businessMenuIconCss"></div>
          <span class="it-tile__label">{{ group.businessMenuGroupName }}</span>
        </div>
        <div
          *ngIf="!group?.businessMenuGroupId"
          class="it-product-group-item it-tile it-product-group-item--empty"
        ></div>
      </ng-container>
    </div>

    <!-- 右：プロダクトメニュー -->
    <div
      class="it-product-menu-container"
      [class.product-maintenance]="activeProductGroupId === BusinessMenuGroupId.Maintenance"
      [class.product-carsales]="activeProductGroupId === BusinessMenuGroupId.Carsales"
      [class.product-repair]="activeProductGroupId === BusinessMenuGroupId.Repair"
    >
      <ng-container *ngFor="let item of activeProductMenuContents">
        <button *ngIf="item?.businessMenuContentId" class="btn it-product-menu-item" (click)="onClickMenu(item)"><span>{{ item?.businessMenuContentName }}</span></button>
        <div *ngIf="!item?.businessMenuContentId" class="it-product-menu-item it-product-menu-item--empty"></div>
      </ng-container>
    </div>

  </div>

</div>

<!-- フッター -->
<div class="it-menu-footer">
  <div class="it-menu-printer-setting" (click)="onClickPrinterSetting()"></div>
  <div class="it-menu-memo">
    <div class="it-menu-memo__icon" (click)="onClickMemoSetting()"></div>
    <div
      class="it-menu-memo__text"
      container="body"
      placement="top"
      [tooltip]="menuMemo"
      containerClass="it-menu-memo-tooltip"
      (click)="onClickMemoSetting()"
    >{{ menuMemo }}</div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/page/biz-menu-page/isshin-tasuke-menu/view/isshin-tasuke-menu-view.component.html